export default __webpack_public_path__ + "static/media/delete_cart.d737d077.svg";